'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MCQQuestionsListItem = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(MCQQuestionsListItem, _Component);

  function MCQQuestionsListItem() {
    (0, _classCallCheck3.default)(this, MCQQuestionsListItem);
    return (0, _possibleConstructorReturn3.default)(this, (MCQQuestionsListItem.__proto__ || (0, _getPrototypeOf2.default)(MCQQuestionsListItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(MCQQuestionsListItem, [{
    key: 'render',
    value: function render() {
      var styles = require('./MCQQuestionsListItem.scss');
      var _props = this.props,
          commonProps = _props.commonProps,
          dragHandle = _props.dragHandle,
          item = _props.item,
          itemSelected = _props.itemSelected;

      var dragged = itemSelected > 0.75;
      var selected = item.index === commonProps.selectedQuestionIndex;

      return _react2.default.createElement(
        'div',
        {
          className: styles.exercisesListItem + (selected ? ' active' : '') + (dragged ? ' dragged' : ''),
          onClick: item.onClick.bind(this, item.index)
        },
        dragHandle(_react2.default.createElement('div', { className: styles.dragHandle })),
        _react2.default.createElement(
          'div',
          { className: styles.exercisesListItemTitle },
          'Question ',
          item.index + 1
        )
      );
    }
  }]);
  return MCQQuestionsListItem;
}(_react.Component), _class.propTypes = {
  commonProps: _react.PropTypes.object.isRequired,
  dragHandle: _react.PropTypes.func.isRequired,
  item: _react.PropTypes.object.isRequired,
  itemSelected: _react.PropTypes.number.isRequired
}, _temp);
exports.default = MCQQuestionsListItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MCQQuestionsListItem/MCQQuestionsListItem.js
// module id = 1178
// module chunks = 0